<ng-container *ngIf="!item.hidden">
  <li
    (mouseenter)="navCollapse($event)"
    data-username="able-pro dashboard dashboard"
    class="nav-item coded-hasmenu"
    [routerLinkActive]="['active']"
    [ngClass]="item.groupClasses"
  >
    <a [routerLinkActive]="['active']" class="nav-link arrow-edge">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
    <ng-container *ngTemplateOutlet="subMenuContent"></ng-container>
  </li>

  <ng-template #itemContent>
    <span class="coded-micon" *ngIf="item.icon">
      <i class="{{ item.icon }}"></i>
    </span>
    <span class="coded-mtext"
      >{{ item.title }}
      <span *ngIf="item.badge" class="badge label" [ngClass]="item.badge.type!">
        {{ item.badge.title }}
      </span>
    </span>
  </ng-template>
  <ng-template #subMenuContent>
    <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item.classes!">
      <ng-container *ngFor="let item of item.children">
        <app-menu-group-horizontal *ngIf="item.type === 'group'" [item]="item"></app-menu-group-horizontal>
        <app-menu-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-menu-collapse>
        <app-menu-item *ngIf="item.type === 'item'" [item]="item"></app-menu-item>
      </ng-container>
    </ul>
  </ng-template>
</ng-container>
